<template>
  <b-modal
      id="client-delete-modal"
      :title="'Supprimer ' + $t('l.client')"
      @ok="handleOk"
      :ok-title="$t('Delete')"
      ok-variant="danger"
      :cancel-title="$t('Cancel')"
      cancel-variant="danger"
      :hide-footer="!canBeDeleted"
  >
    <div v-if="!!selectedClient">
      <div v-if="canBeDeleted">
        Cette action va supprimer
        <span v-if="selectedClient.isAgency">l'agence <strong>{{ selectedClient.agencyName }}</strong></span>
        <span v-else>le client <strong>{{ selectedClient.name }}</strong></span>.
      </div>

      <div v-else>
        <span v-if="selectedClient.isAgency">L'agence <strong>{{ selectedClient.agencyName }}</strong>  ne peut pas être supprimée car elle a des adresses/interventions associées.</span>
        <span v-else>Le client <strong>{{ selectedClient.name }}</strong>  ne peut pas être supprimé car il a des adresses/interventions associées.</span>
      </div>
    </div>
  </b-modal>
</template>

<script>

import api from '../../services/api';

export default {

  name: 'ClientDeleteModal',

  props: {
    selectedClient: Object
  },

  data() {
    return {
      canBeDeleted: false,
      interventionsCount: null,
      addressesCount: null
    }
  },

  watch: {
    'selectedClient': function () {
      if(this.selectedClient != null){
        this.fetchAddressesCount()
      }
    }
  },

  emits: ['didDeleteClient'],

  methods: {

    fetchAddressesCount(){
      return api
        .get(`/addressIntervention/countByClient?clientId=${this.selectedClient.id}`)
        .then(response => {
          this.addressesCount = response.data.count
          this.fetchInterventionsCount()
        })
    },

    fetchInterventionsCount() {
      return api
        .get(`/intervention/countByApplicant?applicantId=${this.selectedClient.id}`)
        .then(response => {
          this.interventionsCount = response.data.count
          this.checkDelete()
        })
    },

    checkDelete() {
      this.canBeDeleted = this.selectedClient && this.addressesCount === 0 && this.interventionsCount === 0
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      let clientName = this.selectedClient.isAgency ? this.selectedClient.agencyName : this.selectedClient.name
      api
          .delete(`/client/${this.selectedClient.id}`)
          .then(response => {
            this.$emit('didDeleteClient')
            this.hideModal()
            this.successToast(this.$i18n.t('Client') + ' "' + clientName + '" ' + this.$i18n.t('deleted'))
          })
          .catch((error) => {
            if (error.response.status === 418) {
              this.$bvToast.toast(error.response.data.message, {
                autoHideDelay: 2000,
                toaster: 'b-toaster-bottom-right'
              })
            }
          });
    },

    hideModal() {
      this.$bvModal.hide('client-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/client/ClientDeleteModal.vue